'use strict';

const h = require('phy');
const Tag = require('@design-system/svg-icons/preact/Tag').default;

const applyCode = props => {
  const {
    applyCodeText,
    handleApplyClick,
    promoAdditionalMessage,
    promoMessage,
    touchRequest,
  } = props;

  return h(
    '.apply-code-wrapper',
    h(
      '.promo-v2-icon-message-wrapper',
      !touchRequest && h(Tag),
      h(
        `.promo-v2-message`,
        promoMessage,
        h('.promo-v2-additional-message', {
          dangerouslySetInnerHTML: { __html: promoAdditionalMessage },
        })
      )
    ),
    h(
      '.apply-code',
      {
        'data-bhw': 'ClickToApplyPromoCode',
        'data-bh-viewport': 'respect',
        onClick: handleApplyClick,
      },
      applyCodeText
    )
  );
};

module.exports = applyCode;
